import React, { useContext } from 'react';
var ScrollContext = React.createContext(null);
/**
 * A higher-order component that provides a scroll context to its children.
 */
export function WithScrollContext(_a) {
    var scrollRef = _a.scrollRef, children = _a.children;
    var context = React.useMemo(function () { return ({
        scrollDownBy: function (px) {
            if (scrollRef.current) {
                scrollRef.current.scrollTop += px;
            }
        },
        scrollUpBy: function (px) {
            if (scrollRef.current) {
                scrollRef.current.scrollTop -= px;
            }
        },
        scrollToTop: function () {
            if (scrollRef.current) {
                scrollRef.current.scrollTop = 0;
            }
        },
        scrollToBottom: function () {
            if (scrollRef.current) {
                scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
        },
    }); }, [scrollRef]);
    return React.createElement(ScrollContext.Provider, { value: context }, children);
}
export var useScrollContext = function () {
    var context = useContext(ScrollContext);
    if (context == undefined) {
        throw new Error('useScrollContext must be used within a scroll context provider');
    }
    return context;
};
